<template>
  <div class="reminder" v-if="reminderText">
    <template v-if="showHeader">
      <h2 class="h4">{{ welcomeMessage }}</h2>
      <p class="reminder__subtitle">
        Hier können Sie Ihre Termine erstellen, verwalten und stornieren
      </p>
    </template>
    <div class="reminder__box" v-if="reminderText">
      <IconCircleInfo aria-hidden="true" />
      <div class="reminder__box__text">
        <p>{{ reminderText.title }}</p>
        <p>{{ reminderText.subtitle }}</p>
      </div>
    </div>
    <hr v-if="showHeader || reminderText" />
  </div>
</template>

<script>
import IconCircleInfo from '@/components/icons/IconCircleInfo.vue'
import { mapGetters } from 'vuex'

export default {
  components: { IconCircleInfo },
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  text: {
    // static
    outstandingMember: {
      title: '[[fee]] € Mitgliedsbeitrag sind leider noch offen',
      subtitle:
        'Sie können gerne dennoch einen Termin vereinbaren. Unsere Mitarbeiter am Stützpunkt werden vor Erbringung der Dienstleistung die offenen Punkte klären.',
    },
  },
  mounted() {
    this.checkForMembershipFee()
  },
  computed: {
    ...mapGetters(['user', 'userHasPaid', 'sessionData', 'membershipFee']),
    welcomeMessage() {
      if (this.user?.isCompany) {
        return 'Willkommen'
      }
      return `Willkommen, ${this.user.firstname} ${this.user.lastname}!`
    },
    reminderText() {
      if (this._hasNotPaid()) {
        return {
          title: this.$options.text.outstandingMember.title.replace(
            '[[fee]]',
            this.membershipFee.replace('.', ',')
          ),
          subtitle: this.$options.text.outstandingMember.subtitle,
        }
      }
      return false
    },
  },
  watch: {
    sessionData() {
      if (this.sessionData) this.checkForMembershipFee()
    },
  },
  methods: {
    checkForMembershipFee() {
      if (this.sessionData) this.$store.dispatch('getMembershipFee')
    },
    _hasNotPaid() {
      return !this.userHasPaid && this.membershipFee > 0
    },
  },
}
</script>

<style lang="scss">
.reminder {
  h4 {
    margin-bottom: 4px;
  }

  &__subtitle {
    @include subtitle;
  }

  &__box {
    border: 1px solid $color-grey-light;
    border-left: 6px solid $color-info-primary;
    border-radius: 4px;
    display: flex;
    padding: 16px;

    svg {
      flex-shrink: 0;
      margin-right: 16px;
    }

    p:first-of-type {
      font-weight: $font-weight-medium;
      margin-bottom: 4px;
    }

    p:last-of-type {
      color: $color-text-secondary;
    }

    a {
      display: inline-block;
      margin-top: 8px;
    }
  }

  > hr {
    @include container-divider;
  }
}
</style>
